import Store from 'store/store';
import { post, request } from 'utils/api';

export async function showLogin() {
	document.getElementById('login')?.showModal();
}
export async function hideLogin() {
	document.getElementById('login')?.close();
}

export async function getCurrentUser() {
	if (__IS_LOCAL__ && location.search.includes('bypass-login')) {
		return { id: '84bc6d0b-0afb-43b1-a543-afa5a87c0ced', name: 'Name', email: 'name@nbcuni.com', role: 'admin', can_be_emailed: false };
	}
	try {
		return await request('/users/me');
	} catch (e) {}
	return null;
}

export async function logOut() {
	await request('/logout');
	showLogin({ source: 'log-out' });
	Store.emit('RESET');
}

export async function getRegions() {
	return await request(`/users/user-regions`).then(res => res?.data);
}

// TODO: Inform user of failure to change region???
export async function changeRegion(region_id) {
	return await post(`/users/change-region`, { region_id }).then(res => res?.region_id);
}
